export default __webpack_public_path__ + "static/media/car-solid.1108f2a7.svg";